const blogData = [
    {
        id: 1,
        title:"How to change Material UI components to match your app's design Part 1",
        // description:"Material UI components are designed to follow Google's Material Design guidelines and will look consistent across different platforms Sometimes, however, you may want to adjust the colors of some elements to match your app's design or create an effect that doesn't have an obvious Material Design equivalent. In these cases, it’s often helpful to customize the components in some way. In this post, we'll walk through some common ways of changing the way Material UI components look on the Website.",
        description:"Material UI components are designed to follow Google's Material Design guidelines ",
        link:"https://dev.to/jay123/how-to-change-material-ui-components-to-match-your-apps-design-part-1-o3f",
        image:"https://res.cloudinary.com/practicaldev/image/fetch/s--_7TpN4zq--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/pnz543k5kv5z585rk210.png",
        pubDate:"Sat, 06 Aug 2022",
        category:["webdev","react","mui","begginers"]
    },
   
    {
        id: 3,
        title:"How to make Your Own Hook",
        description:"React Hooks are simple JavaScript functions that we can use to isolate ",
        link:"https://dev.to/jay123/how-to-make-your-own-hook-24co",
        image:"https://res.cloudinary.com/practicaldev/image/fetch/s--5_VzPt7H--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/mg700lnuplojer62odx0.png",
        pubDate:"Thu, 04 Aug 2022",
        category:["react","javascript","webdev","tutorial"]
    },
    {
        id: 4,
        title:"How to debug Node JS Errors",
        image:"https://res.cloudinary.com/practicaldev/image/fetch/s--sa1rQZ58--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/vpg2tuo3wlb61ehup5k7.png",
        link:"https://dev.to/jay123/how-to-debug-node-js-errors-3j9i",
        description:"Node JS is a server-side platform built using Google Chrome’s JavaScript Engine (V8 Engine) ",
        pubDate:"Wed, 03 Aug 2022",
        category:["node","debug","webdev","javascript"]
    },
     {
        id: 2,
        title:"Stop Memorizing Code",
        description:"Never Memorize what you can look up in Books.If you are trying to  ",
        link:"https://dev.to/jay123/stop-memorizing-code-2nad",
        image:"https://res.cloudinary.com/practicaldev/image/fetch/s--BY6qRATa--/c_imagga_scale,f_auto,fl_progressive,h_420,q_auto,w_1000/https://dev-to-uploads.s3.amazonaws.com/uploads/articles/jhwoujel82izsuc0dkbb.png",
        pubDate:"Fri, 05 Aug 2022",
        category:["carreer","codenewbie","discuss"]
    },
]

export default blogData;
// {
//     title:"",
//     description:"",
//     link:"",
//     image:""
// },